import { Controller } from "@hotwired/stimulus";
import "react_ujs";

export default class extends Controller {
  static targets = ["productSelect"];
  static values = {
    windowItemId: String,
    estimateId: String,
    latestColor: String,
    duplicate: Boolean,
  };

  initialize() {
    // Load options on page load if a product is already selected
    if (this.productSelectTarget && this.productSelectTarget.value) {
      this.loadOptionsWithValue(this.productSelectTarget.value);
    }
  }

  loadOptions(event) {
    const productId = event.target.value;
    this.loadOptionsWithValue(productId);
  }

  loadOptionsWithValue(productId) {
    if (productId) {
      const optionsFrame = document.getElementById("window_options");
      const params = new URLSearchParams();

      if (this.windowItemIdValue) {
        params.append("window_item_id", this.windowItemIdValue);
      }

      if (this.estimateIdValue) {
        params.append("estimate_id", this.estimateIdValue);
      }

      if (this.latestColorValue) {
        params.append("latest_color", this.latestColorValue);
      }

      if (this.duplicateValue) {
        params.append("duplicate", "true");
      }

      optionsFrame.src = `/sales/window_products/${productId}/options?${params.toString()}`;

      // Reinitialize React components after Turbo frame loads
      optionsFrame.addEventListener(
        "turbo:frame-load",
        this.initializeReactComponents,
        { once: true }
      );
    }
  }

  initializeReactComponents() {
    ReactRailsUJS.handleMount();
  }
}
